import { Box, FormControl, Grid, SelectChangeEvent, TextField } from '@mui/material'
import React, { Component } from 'react'
import { appContext } from '../../../AppContext'
import IbssButtonRedo from '../../Buttons/Button/IbssButton'
import IbssInputDropDown from '../../Inputs/SelectList/IbssInputDropDown';

export default class IbssFilter extends Component<ISearchFilterProps>
{
    private get labels() { return appContext().labels; }

    public render(): JSX.Element
    {
        const url = window.location.href;
        const path = new URL(url).pathname;

        return (
            <>
                <Grid container rowSpacing={0} sx={{display:'flex',alignItems:'center',mt:0,ml:0}}>
                    <Grid item xs={this.props.isSystemFilterEnabled || this.props.showExport ? 6 : 12}>
                    <Grid container>
                    <Grid item md={4}>
                        <FormControl fullWidth variant="outlined" sx={{pr:2}}>
                            <TextField
                                fullWidth
                                type="text"
                                size="medium"
                                placeholder={this.labels.HubLabelSearch}
                                value={this.props.searchTerm}
                                onChange={(event) =>
                                    this.props.onSearchTermChange(event)
                                }
                            />
                        </FormControl>
                        </Grid>
                        {this.props.isSystemFilterEnabled &&
                            <Grid item md={4}>
                                <FormControl fullWidth size="small">
                                    <IbssInputDropDown
                                        inputLabel={this.labels.HubLabelPredefinedFilter}
                                        options={this.props.filterOptions ?? []}
                                        value={this.props.selectedFilterId}
                                        id={"filterSelection"}
                                        onChange={(e: SelectChangeEvent<string>) => this.props.filterChanged?.(e.target.value)}
                                    />
                                </FormControl>
                            </Grid>
                        }
                        <Grid item md={2} pl={2} display={'flex'} alignItems={'center'}>
                        {this.props.onFilterButtonClick && (
                            <IbssButtonRedo
                                onClick={this.props.onFilterButtonClick}
                                variant="contained"
                            >
                                {this.labels.HubLabelFilter}
                            </IbssButtonRedo>
                        )}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'right',pt:'0' }}>
                <Box
                    sx={{
                        '& > :not(style)': {my:1,alignItems:"center" },
                    }}
                >
                {this.props.onExportButtonClick && this.props.showExport === true &&
                        <IbssButtonRedo
                            onClick={this.props.onExportButtonClick}
                            disabled={this.props.disableExport}
                            variant="contained"
                            color="secondary"
                        >
                            {this.labels.HubButtonExport}
                        </IbssButtonRedo>
                }
                </Box>
                </Grid>
                </Grid>
            </>
        )
    }
};

export interface ISearchFilterProps
{
    showExport?: boolean;
    filterOptions?: InputOption[];
    selectedFilterId?: string;
    filterChanged?: (filterId: string) => void;
    searchTerm: string;
    isSystemFilterEnabled?: boolean;
    onSearchTermChange: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
    onFilterButtonClick?: () => void;
    onExportButtonClick?: () => void;
    disableExport?: boolean;
}

export class InputOption
{
    label = "";
    value = "";

    constructor(label: string, value: string)
    {
        this.label = label;
        this.value = value;
    }
}
